import React from "react"
import { useSelector } from "react-redux";
import SendIcon from '../assests/sendIcon.png'
import { ActivityTypeEnum } from "../models/ActivityTypeEnum";
import BackdropPopup from "../UI/Popups/BackdropPopup/BackdropPopup";
import classes from './SuccessSubmissionPopup.module.css'

const Final = () => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <>
            <div className={classes.Header}>
                <img className={classes.icon} src={SendIcon} alt="SendIcon" />
                <p>{texts.successSubmissionAssesment}</p>
            </div>
            <div className={classes.submissionPopupTitle}>{texts.successSubmissionPopupTitle}!</div>
            <div className={classes.submissionPopupContent}>{texts.successSubmissionPopupContent}</div>
        </>
    )
}

const Learning = () => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <>
            <div className={classes.Header}>
                <p>{texts.saveAssesment}</p>
            </div>
            <div className={classes.submissionPopupTitle}>{texts.assessmentSavedSuccessfully}!</div>
            <div className={classes.submissionPopupContent}>{texts.returnAssessment}</div>
        </>
    )
}

const SuccessSubmissionPopup = ({ activityType, close, setAssesmentStatus, nextStatus }) => {

    const texts = useSelector(state => state.translate.texts);

    function confirmPopup(e) {
        (nextStatus === "Submitted" || nextStatus === "Resubmitted") && setAssesmentStatus(nextStatus)
        e.stopPropagation()
        close()
    }

    return (
        <BackdropPopup myHeight='200px' >
            <div className={classes.SubmissionPopupContainer}>
                {ActivityTypeEnum[activityType] === ActivityTypeEnum.Final ?
                    <Final /> : <Learning />
                }
                <div className={classes.btnsContainer}>
                    <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={e => confirmPopup(e)}>{texts.ok}</button>
                </div>
            </div>
        </BackdropPopup>
    )
}

export default SuccessSubmissionPopup;